import { getStorage, ref, deleteObject } from "firebase/storage";
import { doc, getDoc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase";

export const deleteFileByUid = async (data) => {
    const {
    pageuid,
    fileuid,
    contentuid,
    companyuid
  } = data || {};
  // ================= VALIDATION =================
  if (!fileuid || typeof fileuid !== "string") {
    return { success: false, error: "Invalid file UID" };
  }

  if (!companyuid || typeof companyuid !== "string") {
    return { success: false, error: "Invalid company UID" };
  }

  try {
    console.log("🔥 DELETE FILE START:", fileuid);

    const fileDocRef = doc(db, "companies", companyuid, "files", fileuid);
    const fileSnap = await getDoc(fileDocRef);

    if (!fileSnap.exists()) {
      console.warn("⚠️ File not found in Firestore");
      return { success: false, error: "File not found" };
    }

    const fileData = fileSnap.data();

    // ✅ SUPPORT BOTH KEYS
    const fileUrl = fileData.url || fileData.fileurl;
    const filePathFromDB = fileData.path; // 🔥 best case if available

    console.log("📂 fileData:", fileData);

    const storage = getStorage();
    let filePath = "";

    // ================= BEST CASE =================
    if (filePathFromDB && typeof filePathFromDB === "string") {
      filePath = filePathFromDB;
    }

    // ================= FALLBACK: PARSE URL =================
    else if (fileUrl && fileUrl.includes("/o/")) {
      const match = fileUrl.match(/\/o\/(.*?)\?/);
      if (match && match[1]) {
        filePath = decodeURIComponent(match[1]);
      }
    }

    // ================= LAST FALLBACK =================
    else if (fileUrl && typeof fileUrl === "string") {
      filePath = fileUrl;
    }

    console.log("📁 FINAL FILE PATH:", filePath);

    // ================= DELETE STORAGE =================
    if (filePath) {
      try {
        const fileRef = ref(storage, filePath);
        await deleteObject(fileRef);
        console.log("✅ Storage file deleted");
      } catch (storageErr) {
        console.error("❌ Storage delete failed:", storageErr.code, storageErr.message);
      }
    } else {
      console.warn("⚠️ No valid file path, skipping storage delete");
    }

    // ================= DELETE FIRESTORE =================
    await deleteDoc(fileDocRef);
    console.log("✅ Firestore record deleted");

    return { success: true };

  } catch (err) {
    console.error("❌ FULL DELETE ERROR:", err);
    return {
      success: false,
      error: err.message || "Delete failed"
    };
  }
};